import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_2 = { class: "text-xs font-bold mt-3 text-gray-800" }
const _hoisted_3 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_4 = { class: "flex items-center justify-center p-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-center p-3" }
const _hoisted_7 = { class: "text-xl font-semibold m-0" }
const _hoisted_8 = { class: "text-xs m-3" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "flex items-center justify-end gap-5 w-full mt-5" }
const _hoisted_11 = { class: "text-center py-5" }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Step = _resolveComponent("Step")
  const _component_StepList = _resolveComponent("StepList")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_StepPanel = _resolveComponent("StepPanel")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Card = _resolveComponent("Card")
  const _component_StepPanels = _resolveComponent("StepPanels")
  const _component_Stepper = _resolveComponent("Stepper")
  const _component_Toast = _resolveComponent("Toast")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isBankUpdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-gray-800 text-xl font-bold" }, "อัปเดตบัญชี", -1 /* HOISTED */)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-[12px] mt-2" }, "กรุณาอัปเดตบัญชีธนาคาร", -1 /* HOISTED */)),
          _createVNode(_component_Button, {
            label: "อัปเดตบัญชี",
            onClick: _ctx.btnClickUpdateBank,
            class: "bg-[#753a13]! border-0! mt-4",
            size: "small"
          }, null, 8 /* PROPS */, ["onClick"])
        ]))
      : (_openBlock(), _createBlock(_component_Stepper, {
          key: 1,
          value: _ctx.stepper,
          "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.stepper) = $event)),
          linear: "",
          pt: {separator:'bg-[#753a13]!'}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_StepList, null, {
              default: _withCtx(() => [
                _createVNode(_component_Step, {
                  value: "1",
                  pt: {header: 'text-xs!', number: 'text-gray-800! text-xs! size-6! min-w-auto!', title:'text-gray-800!'}
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("ระบุจำนวนเงิน")
                  ])),
                  _: 1 /* STABLE */,
                  __: [5]
                }),
                _createVNode(_component_Step, {
                  value: "2",
                  pt: {header: 'text-xs!', number: 'text-gray-800! text-xs! size-6! min-w-auto!', title:'text-gray-800!'}
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("ฝาก")
                  ])),
                  _: 1 /* STABLE */,
                  __: [6]
                }),
                _createVNode(_component_Step, {
                  value: "3",
                  pt: {header: 'text-xs!', number: 'text-gray-800! text-xs! size-6! min-w-auto!', title:'text-gray-800!'}
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("สำเร็จ")
                  ])),
                  _: 1 /* STABLE */,
                  __: [7]
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_StepPanels, { pt: {root: 'px-0!'} }, {
              default: _withCtx(() => [
                _createCommentVNode(" STEP 1 "),
                _createVNode(_component_StepPanel, {
                  value: "1",
                  pt: {root: 'bg-transparent!'}
                }, {
                  default: _withCtx(({ activateCallback }) => [
                    (_ctx.isActive)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "bg-white border-2! border-[#ff8a1f]! rounded-3xl mb-3 p-2" }, [
                            _createElementVNode("p", { class: "text-gray-800 text-[16px]" }, "⚠️ ฝากถอน ขั้นต่ำ 100 บาท"),
                            _createElementVNode("p", { class: "text-gray-800 text-[14px] py-2" }, "สแกน Qr code ผ่านแอปธนาคาร โดยใช้บัญชีที่ลงทะเบียนไว้")
                          ], -1 /* HOISTED */)),
                          _createElementVNode("form", {
                            onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                          }, [
                            _createVNode(_component_IftaLabel, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "amount",
                                  mode: "currency",
                                  currency: "THB",
                                  locale: "th-TH",
                                  modelValue: _ctx.form.amount,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.amount) = $event)),
                                  class: "w-full",
                                  "input-class": "text-gray-800! border"
                                }, null, 8 /* PROPS */, ["modelValue"]),
                                _cache[8] || (_cache[8] = _createElementVNode("label", { for: "amount" }, "ระบุจำนวนเงิน", -1 /* HOISTED */))
                              ]),
                              _: 1 /* STABLE */,
                              __: [8]
                            }),
                            _createElementVNode("p", _hoisted_2, " ฝากขั้นต่ำ " + _toDisplayString(_ctx.amountLimit.min.toLocaleString()) + " บาท สูงสุด " + _toDisplayString(_ctx.amountLimit.max.toLocaleString()) + " บาท ", 1 /* TEXT */),
                            _createVNode(_component_Button, {
                              label: "ฝาก",
                              type: "submit",
                              disabled: _ctx.isAmountInvalid || _ctx.form.btn.loading,
                              loading: _ctx.form.btn.loading,
                              size: "small",
                              class: "bg-[#753a13]! border-0! min-w-20 mt-5"
                            }, null, 8 /* PROPS */, ["disabled", "loading"])
                          ], 32 /* NEED_HYDRATION */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[10] || (_cache[10] = [
                          _createElementVNode("h2", { class: "text-gray-800 text-xl font-bold" }, "ปิดให้บริการชั่วคราว", -1 /* HOISTED */),
                          _createElementVNode("p", { class: "text-[12px] text-gray-800 mt-2" }, " ช่องทางฝากนี้ปิดให้บริการชั่วคราว กรุณาลองช่องทางอื่นๆ ", -1 /* HOISTED */)
                        ])))
                  ]),
                  _: 1 /* STABLE */
                }),
                _createCommentVNode(" STEP 2 "),
                _createVNode(_component_StepPanel, {
                  value: "2",
                  pt: {root: 'bg-transparent!'}
                }, {
                  default: _withCtx(({ activateCallback }) => [
                    _createVNode(_component_Card, {
                      class: "w-full mx-auto mt-3",
                      pt: { header: 'flex justify-center', body: 'p-0!' }
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          (_ctx.bankDeposit.data.img)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.bankDeposit.data.img,
                                class: "w-full",
                                alt: "qrcode"
                              }, null, 8 /* PROPS */, _hoisted_5))
                            : (_openBlock(), _createBlock(_component_ProgressSpinner, {
                                key: 1,
                                style: {"width":"36px","height":"36px"}
                              }))
                        ])
                      ]),
                      footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.bankDeposit.data.amount) + " บาท", 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.bankDeposit.data.orderId), 1 /* TEXT */)
                        ]),
                        _createElementVNode("a", {
                          href: _ctx.bankDeposit.data.qr_link,
                          target: "_blank",
                          class: "block bg-primary text-white p-2 w-max rounded-lg mb-3 mx-auto"
                        }, " คลิกเพื่อฝาก ", 8 /* PROPS */, _hoisted_9)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Button, {
                        onClick: $event => (activateCallback('3')),
                        size: "small",
                        label: "ถัดไป",
                        class: "bg-[#753a13]! border-0!"
                      }, null, 8 /* PROPS */, ["onClick"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createCommentVNode(" STEP 3 "),
                _createVNode(_component_StepPanel, {
                  value: "3",
                  pt: {root: 'bg-transparent!'}
                }, {
                  default: _withCtx(({ activateCallback }) => [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "text-gray-800 text-xl font-bold" }, "เมื่อทำการโอนเงินเรียบร้อยแล้ว", -1 /* HOISTED */)),
                      _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-gray-800 mt-2" }, "ยอดเงินจะถูกเติมเข้า กระเป๋าเกม ภายใน 5 วินาที", -1 /* HOISTED */)),
                      _createVNode(_component_Button, {
                        label: "กลับหน้าหลัก",
                        onClick: $event => (activateCallback('1')),
                        class: "bg-[#753a13]! border-0! mt-4"
                      }, null, 8 /* PROPS */, ["onClick"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["value"])),
    _createVNode(_component_Toast)
  ], 64 /* STABLE_FRAGMENT */))
}